export default __webpack_public_path__ + "static/media/SubTabIcon.1fe7c98a.svg";